window.crearPlantilla = function (event) {
    event.preventDefault();
    cleanFeedback('crearPlantilla', 'crearPlantillaFormularioModal');

    let formData = new FormData(event.target);

    $.ajax({
        url:         urlPlantilla,
        type:        'POST',
        data:        formData,
        processData: false,
        contentType: false,
        beforeSend:  function beforeSend() {
            $('#crearPlantillaBotonEnviar').prop('disabled', true);
            $('#crearPlantillaBotonEnviar').html("<i class=\"ri-loader-4-line ri-formatted spinner\"></i>".concat(transAccionProcesando));
        },
    })
     .done(function (response) {
         $('#crearPlantillaFormularioModalCampoTitulo').val('');
         $('.sinResultadosPlantillas').hide();
         pNotifySuccess(response.message);
         getPlantillas(response.resource.id)
     })
     .fail(function (jqXHR, status, error) {
         showInvalidFeedback(jqXHR, 'crearPlantilla', 'crearPlantillaModal');
     })
     .always(function () {
         $("#crearPlantillaBotonEnviar").prop('disabled', false);
         $("#crearPlantillaBotonEnviar").html("<i class=\"ri-send-plane-2-fill ri-formatted\"></i> ".concat(transAccionCrearPlantilla));
     });
}
